import { useTranslations } from 'next-intl';
import cx from 'classnames';
import CommonIcon from '@/components/CommonIcon';
import Styles from './mIndex.module.scss';

export interface ILinkPreview {
  className?: string;
  id: string;
  link: string;
  title?: string;
  isEdit?: boolean;
  onRemove: (key: string) => void;
}

const LinkPreview = ({
  className = '',
  id,
  link,
  title,
  isEdit,
  onRemove,
}: ILinkPreview) => {
  const t = useTranslations();

  const handleLinkClick = () => {
    if (isEdit || !link) {
      return;
    }

    window.location.href = link;
  };

  const handleRemove = () => {
    onRemove(id);
  };

  return (
    <div className={cx(Styles.root, className)} onClick={handleLinkClick}>
      {
        isEdit && <div className={Styles.removeIcon} onClick={handleRemove} />
      }
      <div className={Styles.title}>{title}</div>
      <div className={Styles.linkWrapper}>
        <CommonIcon className={Styles.icon} icon="link" />
        <div className={Styles.contentWrapper}>
          <div className={Styles.link}>{link}</div>
          <div className={Styles.tips}>{t('tips_link_preview')}</div>
        </div>
      </div>
    </div>
  );
};

export default LinkPreview;
